// extracted by mini-css-extract-plugin
export default {"container":"AddReligion_container__J1mSj","heading":"AddReligion_heading__Y5rB7","form":"AddReligion_form__J3uSo","buttonContainer":"AddReligion_buttonContainer__y3RVs"};